<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-12-25 16:44:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/search/components/SearchProductList/index.vue
-->
<template>
  <div class="product_list">
    <div
      v-for="(item, index) in searchProductList.rows.slice(0, 5)"
      :key="index"
      class="border_bottom1px_shadow list_item"
      @click="goDetail(item.id)"
    >
      <div class="flex_left">
        <div class="left_img">
          <img :src="item.thumbnailImg" alt="" />
        </div>
        <div class="left_name">
          <div class="font12 font_weight500 colo087 name_name text_left">
            {{ item.name }}
          </div>
          <div class="name_name">
            <tags
              :tradeType="item.tradeType"
              :tradeTypeName="item.tradeTypeName"
              :includeTax="item.includeTax"
            />
          </div>
          <div class="font10 font_weight400 colo055 name_num text_left">
            已售：{{ item.salesVolume }}
          </div>
        </div>
      </div>
      <div class="price_right">
        <div class="price_line font12 font_weight400 colo037">
          {{ item.crossedPrice | currency(false) }}
        </div>
        <div class="price_now font16 font_weight600 colof00 line_height_19">
          {{ item.storePrice | currency(false) }}
        </div>
      </div>
    </div>
    <div
      v-if="searchProductList.rows.length > 5"
      class="font12 font_weight400 colo087 look_all"
      @click="lookAll"
    >
      查看所有结果
    </div>
  </div>
</template>
<script>
const Tags = () => import("@/components/Tags").then(m => m.default || m);
export default {
  components: {
    Tags
  },
  data() {
    return {};
  },
  computed: {
    searchProductList() {
      return this.$store.getters.searchProductList;
    }
  },
  methods: {
    lookAll() {
      this.$emit("lookAll");
    },
    goDetail(id) {
      this.$emit("goDetail", id);
    }
  }
};
</script>
<style lang="less" scoped>
.product_list {
  padding: 12px 12px 0;
  background: #fff;
  .list_item {
    margin-top: 8px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
  }
  .flex_left {
    display: flex;
    box-sizing: border-box;
  }
  .left_img {
    width: 72px;
    img {
      width: 100%;
    }
  }
  .left_name {
    padding-left: 12px;
    .name_name {
      // max-width: 60%;
      width: 180px;
      padding-top: 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .name_num {
      padding-top: 4px;
    }
  }
  .price_right {
    margin-top: 27px;
    .price_line {
      text-decoration: line-through;
    }
    .price_now {
      white-space: nowrap;
    }
  }
  .look_all {
    padding: 12px 0;
  }
}
</style>
